module.exports = __webpack_public_path__ + "img/logo_white.96822663.svg";